<template>
  <Head title="Recuperar Contraseña" />
  <div class="min-h-screen flex items-center justify-center bg-gradient-to-r from-blue-100 to-blue-200 p-4">
    <div class="w-full max-w-md">
      <!-- Logo -->
      <logo class="block mx-auto w-full max-w-xs fill-blue-600 transition-transform hover:scale-105" height="50" />

      <!-- Formulario de recuperación -->
      <form @submit.prevent="submit"
        class="mt-8 bg-white rounded-2xl shadow-2xl overflow-hidden transition-all duration-300 hover:shadow-3xl">
        <div class="px-10 py-12">
          <!-- Encabezado -->
          <h1 class="text-center text-3xl font-bold text-gray-800">
            Recuperar Contraseña
          </h1>
          <p class="text-center text-gray-600 mt-2">
            Ingresa tu correo electrónico y te enviaremos instrucciones
          </p>
          <div class="mt-6 mx-auto w-24 border-b-2 border-blue-500" />

          <!-- Campo de correo -->
          <text-input v-model="form.email" :error="form.errors.email" class="mt-10" label="Correo electrónico"
            type="email" placeholder="ejemplo@correo.com" autofocus autocomplete="email" autocapitalize="off" />

          <!-- Mensaje de éxito -->
          <div v-if="status" class="mt-4 text-sm text-green-600">
            {{ status }}
          </div>

          <!-- Enlaces -->
          <div class="text-center mt-6">
            <Link href="/login" class="text-sm text-blue-600 hover:text-blue-800 font-medium">
              Volver al inicio de sesión
            </Link>
          </div>
        </div>

        <!-- Footer con botón -->
        <div class="px-5 py-5 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-blue text-lg font-medium transition-colors"
            type="submit">
            {{ form.processing ? 'Enviando...' : 'Enviar instrucciones' }}
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'
import Logo from '@/Shared/Logo'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import { Link } from '@inertiajs/inertia-vue3'

export default {
  name: 'Forgot',

  components: {
    Head,
    LoadingButton,
    Logo,
    TextInput,
    Link,
  },

  props: {
    status: String,
  },

  data() {
    return {
      form: this.$inertia.form({
        email: '',
      }),
    }
  },

  methods: {
    submit() {
      this.form.post('/forgot-password', {
        onSuccess: () => {
          this.form.reset()
        },
      })
    },
  },
}
</script> 